<template>
  <div class="lg:hidden">
    <div
      :class="containerClasses"
      class="grid gap-4"
    >
      <div
        v-for="(item, index) in visibleItems"
        :key="index"
        class="flex flex-col"
      >
        <ProductGroupsItem
          :item="item"
          :text-color="textColor"
          :background-color="backgroundColor"
          :image-height="PRODUCT_GROUPS_SLIDER.MOBILE_IMAGE_HEIGHT"
        />
      </div>
    </div>
    <button
      v-if="shouldShowToggleAllButton"
      class="mt-4 bg-EXPONDO-white border border-EXPONDO-grey-20
        h-9 w-full flex items-center justify-center rounded-b-lg"
      @click="toggleShowAll"
    >
      <span
        class="iconify svg--chevron-right"
        :class="isCheveronRotated"
      />
    </button>
  </div>
</template>
<script lang="ts">
import type { PropType } from 'vue';
import ProductGroupsItem from './ProductGroupsItem.vue';
import type { ProductGroupsItemType } from '~~/types/cms/ProductGroupsItem';
import {
  PRODUCT_GROUPS_SLIDER,
} from '~~/constants/cms';

export default defineComponent({
  name: 'ProductGroupsMobileTiles',
  components: { ProductGroupsItem },
  props: {
    items: {
      type: Array as PropType<Array<ProductGroupsItemType>>,
      required: true,
    },
    textColor: {
      type: String,
      default: 'text-EXPONDO-black',
    },
    backgroundColor: {
      type: String,
      default: 'bg-EXPONDO-grey-5',
    },
  },
  setup(props) {

    const showAll = ref(false);
    const visibleItems = computed(() => {

      return showAll.value ? props.items : props.items.slice(0, PRODUCT_GROUPS_SLIDER.MAX_VISIBLE_ITEMS);
    
    });

    const shouldShowToggleAllButton = computed(() => {

      return props.items.length > PRODUCT_GROUPS_SLIDER.MAX_VISIBLE_ITEMS;
    
    });

    const toggleShowAll = () => {

      showAll.value = !showAll.value;
    
    };

    const containerClasses = computed(() => {

      if (props.items.length === PRODUCT_GROUPS_SLIDER.MIN_ITEMS) {

        return 'grid-cols-3';
      
      } else {

        return 'grid-cols-2';
      
      }
    
    });

    const isCheveronRotated = computed(() => {

      return showAll.value ? '-rotate-90' : 'rotate-90';
    
    });

    return {
      visibleItems,
      showAll,
      toggleShowAll,
      containerClasses,
      PRODUCT_GROUPS_SLIDER,
      shouldShowToggleAllButton,
      isCheveronRotated,
    };
  
  },
});

</script>
